// src/common/utils/reloadUserData.ts
import { getApi } from "../../../api/api";
import { store } from "../../../store/store";
import { setOrders } from "../../../store/slices/orderSlice";
import {
  setBonusData,
  setBonusHistory,
} from "../../../store/slices/bonusSlice";
import { setAddresses } from "../../../store/slices/addressSlice";
import { setFavorites } from "../../../store/slices/favoritesSlice";

export const reloadUserData = async () => {
  const api = getApi();

  const [orders, bonusData, addresses, favorites, bonusHistory] =
    await Promise.allSettled([
      api.getOrderList(),
      api.getBonusBalance(),
      api.getAddressList(),
      api.getUserFavorites({ limit: 1000 }),
      api.getBonusHistory(20, 0),
    ]);

  if (orders.status === "fulfilled" && orders.value) {
    store.dispatch(setOrders(orders.value));
  }
  if (bonusData.status === "fulfilled" && bonusData.value) {
    store.dispatch(setBonusData(bonusData.value));
  }
  if (addresses.status === "fulfilled" && addresses.value) {
    store.dispatch(setAddresses(addresses.value));
  }
  if (favorites.status === "fulfilled" && favorites.value) {
    store.dispatch(setFavorites(favorites.value));
  }
  if (bonusHistory.status === "fulfilled" && bonusHistory.value) {
    store.dispatch(setBonusHistory(bonusHistory.value));
  }
};
